

























































import { Component, Vue } from "vue-property-decorator";
import LoginWidget from "@/components/LoginWidget.vue";
import ModalView from "@/components/design/ModalView.vue";
import { functions } from "@/firebase";

@Component({ components: { ModalView, LoginWidget } })
export default class RedeemView extends Vue {
  redeemCodeError = false;

  showSuccessModal = false;

  inviteCode = "";

  async created() {
    if (this.$route.query.code) {
      this.inviteCode = this.$route.query.code as string;
      await this.redeemCode();
    }
  }

  async redeemCode() {
    this.$store.commit("setLoading");
    const confirmBetaCodeResult = await functions.httpsCallable("confirmBetaCode")(this.inviteCode);
    if (confirmBetaCodeResult.data.success) {
      this.showSuccessModal = true;
    } else {
      this.redeemCodeError = true;
    }
    this.$store.commit("setNotLoading");
  }
}
